import React, { useMemo } from 'react';
import { numFormatter } from '../../../../core/utils/number';
import { HdIcon } from '../../../../components';
import { GraphConstants } from '../../../../chart/constants/eventBarGraph';
import { convertActivationStatsDataPointsToStackedData } from '../utils';
import ActivationBarGraph from './ActivationBarGraph';

function ActivationRunGraph({
  stageInfo,
  stageDataPoints,
  maxPoints = GraphConstants.activationEventsBarCount,
}) {

  const totalEvents = useMemo(() =>
      stageDataPoints.reduce((total, dataPoint) => total + dataPoint.total + dataPoint.failed, 0)
    , [stageDataPoints]);

  const barGraphPoints = useMemo(() => {
    return convertActivationStatsDataPointsToStackedData(stageDataPoints, stageInfo);
  }, [stageDataPoints, stageInfo]);

  return (
    <div className='flex-col justify-between flex-1'>
      <div className='center-flex-row mb-2'>
        <HdIcon name={stageInfo.stageIcon} />

        <span className='text-bold text-body-2 ml-2'>
          {stageInfo.name}
        </span>
      </div>

      <div className='d-flex align-items-end justify-between'>
        <div className='text-primary text-title-3'>
          {totalEvents ? numFormatter(totalEvents) : 0}
        </div>

        <ActivationBarGraph
          points={barGraphPoints}
          boxHeight={40}
          barWidth={5}
          barsSpacing={2}
          noOfBars={maxPoints}
        />
      </div>
    </div>
  );
}

export default ActivationRunGraph;
